import React from "react";
import HeaderTwo from "../../components/HeaderTwo";
import { BreadcrumbBox } from "../../components/common/Breadcrumb";
import AboutUs from "../../components/AboutUs";
import IconBox from "../../components/IconBox";
import CountryBox from "./../../components/CountriesBox";
import TestimonialSlider from "../../components/TestimonialSlider";
import FaqEvent from "../../components/FaqEvent";
import FooterTwo from "../../components/FooterTwo";
import "./styles/countries.css";

const Countries = () => {
  return (
    <>
      {/* Main Wrapper */}
      <div className="main-wrapper about-page countries-page">
        {/* Header 2 */}
        <HeaderTwo />

        {/* Breadcroumb */}
        <BreadcrumbBox />

        {/* About Area */}
        <AboutUs />

        {/* Icon Box Area */}
        <IconBox />

        {/* Tab Section */}
        <CountryBox services={true} />

        {/* Testimonial Slider */}
        <TestimonialSlider />

        {/* Faq & Event Area */}
        <FaqEvent />

        {/* Footer 2 */}
        <FooterTwo />
      </div>
    </>
  );
};

export default Countries;
